import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { ReactComponent as Activity24Icon } from 'assets/svgs/activity.svg';
import {
  ListItem,
  ListItemMeta,
  SingleLineLabel,
} from 'components/atoms/select/custom-components';
import { OptionProps } from 'components/atoms/select/types';
import { StatusIndicatorIcon } from 'components/molecules/status-indicator';
import { StatusIndicatorWrapper } from 'components/organisms/timesheets/common/cells/name-cell';

const StyledListItem = styled(ListItem)`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
`;

export const EntityOption = (props: OptionProps): JSX.Element => {
  const { data, isFocused, isSelected } = props;

  const getTaskField = (fields, fieldName) =>
    fields.find((field) => field.fieldName === fieldName);

  return (
    <components.Option {...props}>
      <StyledListItem>
        <StatusIndicatorWrapper>
          {['TASK_ENTRY', 'PHASE_ENTRY', 'MILESTONE_ENTRY'].includes(
            data.type,
          ) ? (
            <StatusIndicatorIcon
              group={
                data.type === 'PHASE_ENTRY'
                  ? data.extra.fields[0].fieldValue
                  : getTaskField(data.extra.fields, 'Status')?.fieldValue
              }
              type={data.extra.type}
              progress={data.extra.progress}
            />
          ) : (
            <Activity24Icon />
          )}
        </StatusIndicatorWrapper>
        <ListItemMeta
          isFocused={isFocused}
          isSelected={isSelected}
          title={<SingleLineLabel>{data.label}</SingleLineLabel>}
          description={data.description}
        />
      </StyledListItem>
    </components.Option>
  );
};
